"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var $ = require("jquery");
var axios_1 = require("axios");
var NotificationsSettings = /** @class */ (function (_super) {
    __extends(NotificationsSettings, _super);
    function NotificationsSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.countries = [
            {
                id: 1,
                name: 'USA',
                selected: false
            },
            {
                id: 2,
                name: 'Canada',
                selected: false
            },
            {
                id: 3,
                name: 'Indonesia',
                selected: false
            },
            {
                id: 4,
                name: 'Mexico',
                selected: true
            }
        ];
        _this.selectedCountries = [];
        _this.isAllChecked = false;
        return _this;
    }
    NotificationsSettings.prototype.saveSettings = function () {
        console.log(this.selectedCountries);
        axios_1.default.post('/settings', this.selectedCountries)
            .then(function (response) {
            console.log(response);
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    NotificationsSettings.prototype.selectCountry = function () {
        $("#selectAllCountries").prop('checked', false);
        this.isAllChecked = false;
    };
    NotificationsSettings.prototype.selectAll = function () {
        this.isAllChecked = !this.isAllChecked;
        this.selectedCountries = [];
        if (this.isAllChecked) {
            for (var i = 0; i < this.countries.length; i++) {
                this.selectedCountries.push(this.countries[i]);
            }
        }
    };
    NotificationsSettings.prototype.setSelectedCountries = function () {
        this.selectedCountries = [];
        for (var i = 0; i < this.countries.length; i++) {
            if (this.countries[i].selected) {
                this.selectedCountries.push(this.countries[i]);
            }
        }
    };
    NotificationsSettings.prototype.closeModal = function () {
        this.setSelectedCountries();
        this.selectCountry();
        var notification = $('#notModal');
        notification.modal('hide');
    };
    NotificationsSettings.prototype.closeModalOutside = function () {
        var _this = this;
        $("#notModal").on('hidden.bs.modal', function () {
            _this.closeModal();
        });
    };
    NotificationsSettings = __decorate([
        (0, vue_property_decorator_1.Component)({
            mounted: function () {
                // $('#notModal').modal();
                this.setSelectedCountries();
                this.closeModalOutside();
            },
            watch: {
                selectedCountries: function (newVal, oldVal) {
                    console.log(newVal);
                    console.log(oldVal);
                }
            }
        })
    ], NotificationsSettings);
    return NotificationsSettings;
}(vue_property_decorator_1.Vue));
exports.default = NotificationsSettings;
